import { Box, Checkbox, Divider, FormControl, FormControlLabel } from '@mui/material';
import TextArea from 'app/components/AccordionCustom/AttachDetails/TextArea';
import CustomFileUpload from 'app/components/CustomFileUpload';
import React from 'react';
import { green } from 'app/components/ThemeProvider/colors';
import CustomInput from 'app/components/CustomInput';
import FieldError from 'app/components/FieldError';
import logger from 'app/utils/logger';
import CustomSwitch from 'app/components/CustomSwitch';

interface Props {
  fileSize?: string;
  attachment?: boolean;
  edv?: boolean;
  register?: any;
  errors?: any;
  contractNumber?: any;
  file?: any;
  onDrop?: any;
  deleteFile?: any;
  errorFileSize?: boolean;
  fileName?: any;
  avans?: any;
  avansValue?: any;
  handleSwitchAvans?: any;
  dataForm?: any;
  handleSwitchEdv?: any;
  valueTaxEnabled?: any;
  values?: any;
  handleChangeInvoiceNo?: any;
  invoiceValue?: any;
  maxLength?: any;
  valueTextArea?: any;
  handleChangeTextArea?: any;
}

const AttachDetailsComponent = (props: Props) => {
  const {
    fileSize,
    attachment,
    edv,
    errors,
    register,
    contractNumber,
    file,
    onDrop,
    deleteFile,
    errorFileSize,
    fileName,
    avans,
    avansValue,
    handleSwitchAvans,
    dataForm,
    handleSwitchEdv,
    valueTaxEnabled,
    values,
    handleChangeInvoiceNo,
    invoiceValue,
    maxLength,
    valueTextArea,
    handleChangeTextArea,
  } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
      {contractNumber && (
        <FormControl
          sx={{
            width: 'calc((100% - 28px) / 2)',

            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              flexDirection: 'column',
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Müqavilə/Hesab faktura nömrəsi'}
            placeholder={'Müqavilə/Hesab faktura nömrəsi'}
            rest={{ ...register('contractNumber'), maxLength: 18 }}
            isValid={errors?.contractNumber !== undefined || dataForm?.error?.fields.contract_no !== undefined}
          />
          <FieldError
            error={
              errors.contractNumber
                ? errors.contractNumber
                : dataForm?.error?.fields.contract_no && { message: dataForm?.error?.fields.contract_no }
            }
          />
        </FormControl>
      )}
      {avans && (
        <>
          <CustomSwitch
            title={'Avans ödənişi (Xarici ticarət)'}
            checked={avansValue}
            handleToggle={handleSwitchAvans}
          />
          <Box
            sx={{
              display: 'flex',
              gap: '28px',
              width: '100%',

              '@media screen and (max-width: 768px)': {
                flexDirection: 'column',
                width: '100%',
              },
            }}
          >
            <FormControl
              sx={{
                width: 'fit-content',
                '@media screen and (max-width: 1100px)': {
                  width: 'calc((100% - 28px) / 2)',
                },

                '@media screen and (max-width: 768px)': {
                  width: '100%',
                },
              }}
            >
              <CustomInput
                title={'Müqavilə/Hesab faktura nömrəsi'}
                placeholder={'Müqavilə/Hesab faktura nömrəsi'}
                rest={{ ...register('contractNumber'), maxLength: 18 }}
                isValid={errors?.contractNumber !== undefined || dataForm?.error?.fields.contract_no !== undefined}
              />
              <FieldError
                error={
                  errors.contractNumber
                    ? errors.contractNumber
                    : dataForm?.error?.fields.contract_no && { message: dataForm?.error?.fields.contract_no }
                }
              />
            </FormControl>
            {avansValue && (
              <FormControl
                sx={{
                  width: 'fit-content',
                  '@media screen and (max-width: 1100px)': {
                    width: 'calc((100% - 28px) / 2)',
                  },

                  '@media screen and (max-width: 768px)': {
                    width: '100%',
                  },
                }}
              >
                <CustomInput
                  title={'Gömrük kodu'}
                  placeholder={'Gömrük kodu'}
                  rest={{ ...register('invoiceNo'), maxLength: 9, minLength: 9 }}
                  isValid={errors?.invoiceNo !== undefined || dataForm?.error?.fields.invoice_no !== undefined}
                  handleChange={handleChangeInvoiceNo}
                  value={invoiceValue}
                />
                <FieldError
                  error={
                    errors.invoiceNo
                      ? errors.invoiceNo
                      : dataForm?.error?.fields.invoice_no && { message: dataForm?.error?.fields.invoice_no }
                  }
                />
              </FormControl>
            )}
          </Box>
        </>
      )}
      <TextArea
        errors={errors}
        register={register}
        dataForm={dataForm}
        values={values}
        maxLength={maxLength}
        valueTextArea={valueTextArea}
        handleChangeTextArea={handleChangeTextArea}
      />
      {attachment && (
        <FormControl>
          <CustomFileUpload
            fileSize={fileSize}
            name={fileName}
            file={file}
            onDrop={onDrop}
            deleteFile={deleteFile}
            errorFileSize={errorFileSize}
          />
          <FieldError error={errors.fileInBank} />
        </FormControl>
      )}
      {edv && (
        <>
          <Divider />
          <FormControlLabel
            control={
              <Checkbox
                checked={valueTaxEnabled}
                onChange={handleSwitchEdv}
                sx={{
                  color: 'rgba(20, 25, 31, 0.22)',
                  mr: '8px',
                  p: '0',
                  '&.Mui-checked': {
                    color: green,
                  },
                }}
              />
            }
            label={'18% ƏDV üçün ödəniş tapşırığı yaradılsın'}
            sx={{ fontFamily: 'Yelo', mt: '10px', mr: '0', ml: '0' }}
          />
        </>
      )}
    </Box>
  );
};

export default AttachDetailsComponent;
